import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { FormField } from '../../FormField/FormField';
import { ClientType } from '../types';

interface Props {
  clientType: ClientType;
  onChange: (clientType: ClientType) => void;
}

/** Chooses between a new client without an account and an existing client. */
export const ClientTypeField = ({ clientType, onChange }: Props) => (
  <FormField labelTitle='Tipo de cliente' elementId='client-type' fullWidth>
    <Dropdown
      value={clientType}
      options={[
        { label: 'Nuevo', value: 'unregistered' },
        { label: 'Existente', value: 'registered' },
      ]}
      onChange={(e) => onChange(e.value)}
    />
  </FormField>
);
